import { unset, set, camelCase } from 'lodash';

import { actions } from 'src/constants';

const INITIAL_STATE = {};

const syncActionTypes = [
  actions.ACTION_SET,
  actions.ACTION_REMOVE,
  actions.OPEN_ONE_NOTIFICATION,
  actions.OPEN_MANY_NOTIFICATIONS,
  actions.CLOSE_NOTIFICATION,
  actions.SHOW_LOADER,
  actions.HIDE_LOADER,
];

const actionTypeRegExp = new RegExp(
  '@([A-Z0-9_]+)/' +
  `(${syncActionTypes.join('|')})` +
  '(_[A-Z_]+)?'
);

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  if (!type) {
    return state;
  }

  const matchResult = type.match(actionTypeRegExp);

  if (!matchResult) {
    return state;
  }

  const [
    match, // eslint-disable-line
    namespace,
    actionType,
    identifier
  ] = matchResult;

  const storePath = [camelCase(namespace), camelCase(identifier)];
  const nextState = { ...state };
  const notifications = state?.notifications || [];

  switch (actionType) {
    case actions.ACTION_SET:
      return set(nextState, storePath, payload);
    case actions.ACTION_REMOVE: {
      unset(nextState, storePath);

      return nextState;
    }
    case actions.OPEN_ONE_NOTIFICATION:
    case actions.OPEN_MANY_NOTIFICATIONS: {
      const { config } = action;
      const newNotifications =
        actionType === actions.OPEN_ONE_NOTIFICATION ? [...notifications, config] :
          [...notifications, ...config];

      return {
        ...nextState,
        notifications: newNotifications
      };
    }
    case actions.CLOSE_NOTIFICATION: {
      const { config } = action;

      return {
        ...nextState,
        notifications: notifications.filter((item) => item.id !== config.id)
      };
    }
    case actions.SHOW_LOADER:
      return {
        ...nextState,
        isLoaderVisible: true
      };
    case actions.HIDE_LOADER:
      return {
        ...nextState,
        isLoaderVisible: false
      };
    default:
      return state;
  }
};
